import React from 'react';
import RefundPolicy from '../components/RefundPolicy/RefundPolicy';

export default function RefundPolicyPage() {
  return <RefundPolicy />;
}

